/**
 * Standard 'socket.io' event names understood by the 'socket.io' server.
 *
 * @enum {string} SOCKET_EVENTS
 * @readonly
 */
export const SOCKET_EVENTS = {
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    RECONNECT: 'reconnect',
    CONNECT_ERROR: 'connect_error'
}
